import React from "react";

import { PatientsDetail } from "../user";

export default function Detail(props) {
  return <PatientsDetail isAdmin {...props} />;
}
